import { useState, useEffect } from 'react';

export const useMenu2 = () => {
    const [isMenu2, setIsMenu2] = useState(false);
    
    useEffect(() => {
        setIsMenu2(window.location.pathname.startsWith('/order/menu2/'));
    }, []);

    return {
        isMenu2,
    };
};
